import React, { useState } from 'react';

import { Paper, Popper, Typography } from '@mui/material';

interface IProps {
  title: string;
}

const ShowPopper: React.FC<IProps> = ({ title }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showPopper, setShowPopper] = useState<boolean>(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setShowPopper(true);
  };

  const handleMouseLeave = () => {
    setShowPopper(false);
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <Typography
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          whiteSpace: 'nowrap',
          maxWidth: '270px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: 'pointer',
        }}
      >
        {title}
      </Typography>
      {showPopper && Boolean(anchorEl) && (
        <Popper
          open={showPopper && Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom-start"
          disablePortal
        >
          <Paper
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            elevation={1}
            sx={{
              padding: 1,
              maxWidth: 300,
              wordBreak: 'break-word',
              backgroundColor: 'background.paper',
            }}
          >
            <Typography
              variant="body2"
              sx={{ padding: 1, whiteSpace: 'wrap', wordWrap: 'break-word' }}
            >
              {title}
            </Typography>
          </Paper>
        </Popper>
      )}
    </React.Fragment>
  );
};

export default ShowPopper;
